export default __webpack_public_path__ + "static/media/q2.d4e354e7.png";